/**
 * TanStack Router: /performance/okrs
 *
 * This route file was auto-generated by the route generation script.
 * Component: PerformanceOkrsPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import PerformanceOkrsPage from '@/app/performance/okrs/page'

/**
 * Route: /performance/okrs
 * Layout: _auth (authenticated)
 * Component: PerformanceOkrsPage
 */
export const Route = createFileRoute('/_auth/performance/okrs')({
  component: PerformanceOkrsPage,
})
